import { Editor } from "@tiptap/react";
import { useQuery } from "react-query";
import { findAllReflections } from "./helper";

export const useReflections = (editor: Editor) => {
  return useQuery(["reflections", Boolean(editor)], () =>
    findAllReflections(editor)
  );
};
